(function() {

  'use strict';

  function loader() {
    return {
      restrict: 'EA',
      scope: {
        pagePayload: '=pagePayload',
        message: '=message',
        requestStatusVariableToWatch: '=requestStatusVariableToWatch'
      },
      templateUrl: 'app/directives/loaderDirective/loader.template.html',
      link: function(scope) {
        
        scope.showLoader = true;
        scope.noData = false;

        if (scope.requestStatusVariableToWatch) {
          scope.$watch(function() {
            return scope.requestStatusVariableToWatch
          }, function() {
            switch (scope.requestStatusVariableToWatch) {
              case "LOADER_CONSTANTS":
              scope.showLoader = true;
              scope.noData = false;
              break;
              case "DATA_RECEIVED_EMPTY":
              scope.showLoader = false;
              scope.noData = true;
              break;
              case "DATA_RECEIVED_NON_EMPTY":
              scope.showLoader = false;
              scope.noData = false;
              break;
              default:
              scope.showLoader = false;
              scope.noData = false;
              break;
            }
          });
        }

        scope.$watch(function() {
          return scope.pagePayload;
        }, function() {
          if (scope.pagePayload) {
            scope.showLoader = false;
            if (scope.pagePayload.page && scope.pagePayload.page.totalElements < 1) {
              scope.noData = true;
            } else {
              scope.noData = false;
            }
          }
        }, true);
      }
    };
  }

  loader.$inject = [];

  angular
    .module('printix-admin')
    .directive('loader', loader)
    .constant("LOADER_CONSTANTS", {
      DATA_LOADING: "LOADER_CONSTANTS",
      DATA_RECEIVED_EMPTY: "DATA_RECEIVED_EMPTY",
      DATA_RECEIVED_NON_EMPTY: "DATA_RECEIVED_NON_EMPTY"
    });
})();